import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'

const PreceptorCard = ( { className, card } ) => {
    return (
        <Link
            to={`preceptores/${card.id}/edit`}
            className={`${className} card-100 card-body`}
        >
            <div className="d-flex flex-direction-column">
                <p className="semi-bold brown">
                    Nome:{' '}
                    <span className="ml-1" style={{ color: '#313131' }}>
                        {card.nome}
                    </span>
                </p>
                <p className="semi-bold brown">
                    RQE:{' '}
                    <span className="ml-1" style={{ color: '#313131' }}>
                        {card.rqe}
                    </span>
                </p>
            </div>
        </Link>
    )
}

PreceptorCard.propTypes = {
    className: PropTypes.string,
    nome: PropTypes.string.isRequired,
    id: PropTypes.number.isRequired,
}

PreceptorCard.defaultProps = {
    className: '',
}

export default PreceptorCard
